import React from 'react';
import AccomplishmentsTab from './AccomplishmentsTab';

const AccomplishmentsView = (props) => {
  return <AccomplishmentsTab {...props} />;
};

export default AccomplishmentsView;
